import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { GeneralSettings, AdminSettingsResponse } from '@models/admin-settings';

@Injectable({
  providedIn: 'root'
})
export class AdminSettingsService {
  private baseUrl = environment.baseUrl + 'AdminSettings/';

  // getGeneralSettings(): Observable<GeneralSettings> {
  //   return this.http.get<GeneralSettings>(this.baseUrl + 'general');
  // }

  constructor(private http: HttpClient) { }

  /* */
  getGeneralSettings(): Observable<AdminSettingsResponse> {
    /*const mockData: AdminSettingsResponse = {
      generalSettings: {
        applicationName: 'Intercessory Prayer Training',
        defaultLanguage: 'en',
        applicationDescription: 'A platform for intercessory prayer training and management.',
        restrictUserRegistration: false,
        maintenanceMode: false
      },
      success: true,
      message: 'Settings retrieved successfully'
    };

    //Return the mock data as an observable
    return of(mockData);*/
    console.log('Fetching General Settings from API');
    // Uncomment below to use actual HTTP call
    return this.http.get<AdminSettingsResponse>(this.baseUrl + 'general');
  }

  /* Save General Settings */
  saveGeneralSettings(settings: GeneralSettings): Observable<AdminSettingsResponse> {
    console.log('Saving General Settings:', settings);
    // For now, return a mock success response
    // const mockResponse: AdminSettingsResponse = {
    //   generalSettings: settings,
    //   success: true,
    //   message: 'General settings saved successfully'
    // };
    // return of(mockResponse);

    //future API Call
    return this.http.put<AdminSettingsResponse>(this.baseUrl + 'general', settings);
  }

  /* Check if user registration is restricted */
  isRegistrationRestricted(): Observable<boolean> {
    console.log('Checking if user registration is restricted');
    console.log('Calling endpoint:', this.baseUrl + 'IsRegistrationRestricted');
    return this.http.get<{ RestrictUserRegistration: boolean }>(this.baseUrl + 'IsRegistrationRestricted')
      .pipe(
        map(result => {
          console.log('Registration restriction API response:', result);
          return result.RestrictUserRegistration;
        }),
        catchError(error => {
          console.error('Error checking registration restriction:', error);
          console.error('Error status:', error.status);
          console.error('Error message:', error.message);
          console.error('Error url:', error.url);
          return of(false); // Default to allowing registration if error
        })
      );
  }

  /* Check if application is in maintenance mode */
  isMaintenanceMode(): Observable<boolean> {
    console.log('Checking if application is in maintenance mode');
    return new Observable(observer => {
      this.getGeneralSettings().subscribe({
        next: (response) => {
          if (response.success) {
            observer.next(response.generalSettings.maintenanceMode);
          } else {
            observer.next(false); // Default to not in maintenance if error
          }
          observer.complete();
        },
        error: (error) => {
          console.error('Error checking maintenance mode:', error);
          observer.next(false); // Default to not in maintenance if error
          observer.complete();
        }
      });
    });
  }
}


    // return this.http.get<AdminSettingsResponse>(this.baseUrl + 'general');
    //return this.http.put<AdminSettingsResponse>(this.baseUrl + 'general', settings);